import { metaAdapter } from "../adapters/metaAdapter";
import AdsCreateTemplate from "../common/AdsCreateTemplateView";

export default function CreateMetaTemplateView({ template }: { template?: any }) {
  return <AdsCreateTemplate adapter={metaAdapter} template={template} />;
}
